module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-06-372c4cc0ae6ee97c3fccf588bc41ef60.jpg";